/**
 * SectionList.js
 */

import React from 'react';
import styled from 'styled-components';
import SectionItem from './SectionItem';

export default function SectionList({
	sections,
	targetHeader,
	headerId,
	documentTypeId,
	taskId,
	source,
	onShowDrawerChanges,
	selectedDocumentsCount
}) {
	if (sections && sections.length > 0) {
		return (
			<Wrapper className="StyledSectionList">
				{sections.map((section) => {
					return (
						<SectionItem
							key={section.id}
							documentTypeId={documentTypeId}
							targetHeader={targetHeader}
							headerId={headerId}
							section={section}
							taskId={taskId}
							source={source}
							onShowDrawerChanges={onShowDrawerChanges}
							selectedDocumentsCount={selectedDocumentsCount}
						/>
					);
				})}
			</Wrapper>
		);
	}

	return null;
}

const Wrapper = styled.section`
	display: flex;
	flex-direction: column;
	flex: 1;
	height: 100%;
	overflow-y: auto;
	position: relative;
	border-top: var(--px-1) solid var(--neutrals-300);
	padding-bottom: var(--px-24);
`;
